/* GARDEN EQUIPMENT — Page catalogue (reproduction catalogue.tsx)
   Filtrage client (marque / catégorie / stock), tri, recherche IA inline. */
(function () {
  "use strict";

  var root = document.querySelector("[data-ge-cat]");
  if (!root) return;

  var grid = root.querySelector("[data-ge-cat-grid]");
  var items = grid ? Array.prototype.slice.call(grid.querySelectorAll(".ge-cat__item")) : [];
  var countEl = root.querySelector("[data-ge-cat-count]");
  var toolbar = root.querySelector("[data-ge-cat-toolbar]");
  var pillsWrap = root.querySelector("[data-ge-cat-pills]");
  var pillsList = root.querySelector("[data-ge-cat-pills-list]");
  var resetBtn = root.querySelector("[data-ge-cat-reset]");
  var emptyBox = root.querySelector("[data-ge-cat-empty]");
  var listing = root.querySelector("[data-ge-cat-listing]");

  // Recherche IA
  var input = root.querySelector("[data-ge-cat-search]");
  var clearBtn = root.querySelector("[data-ge-cat-clear]");
  var spinner = root.querySelector("[data-ge-cat-spin]");
  var aiSection = root.querySelector("[data-ge-cat-ai]");
  var aiGrid = root.querySelector("[data-ge-cat-ai-grid]");
  var aiHead = root.querySelector("[data-ge-cat-ai-head]");
  var aiMsg = root.querySelector("[data-ge-cat-ai-msg]");
  var aiEmpty = root.querySelector("[data-ge-cat-ai-empty]");
  var aiEmptyText = root.querySelector("[data-ge-cat-ai-empty-text]");
  var aiClearAll = root.querySelectorAll("[data-ge-cat-ai-clear]");

  // Sort dropdown
  var sortBtn = root.querySelector("[data-ge-cat-sort-btn]");
  var sortMenu = root.querySelector("[data-ge-cat-sort-menu]");
  var sortLabel = root.querySelector("[data-ge-cat-sort-label]");

  var T = (window.GE_CAT_I18N || {});
  var endpoint = (window.GE_AI && window.GE_AI.endpoint) || "";

  var state = { brand: "all", category: "all", stock: false, sort: "BEST_SELLING" };

  function isPro() { return document.documentElement.classList.contains("ge-is-b2b"); }
  function esc(s) { return (s || "").replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function fmt(tpl, q) { return (tpl || "").replace("{query}", q); }

  /* ---------- Filtrage + tri ---------- */
  function applyFilters() {
    var visible = 0;
    var shown = [];
    items.forEach(function (el) {
      var ok = true;
      if (state.brand !== "all" && (el.getAttribute("data-vendor") || "").indexOf(state.brand) === -1) ok = false;
      if (ok && state.category !== "all" && !typeMatches(el, activeTypes())) ok = false;
      if (ok && state.stock && el.getAttribute("data-available") !== "true") ok = false;
      el.hidden = !ok;
      if (ok) { visible++; shown.push(el); }
    });

    // Tri : réordonne les éléments visibles dans le DOM
    if (state.sort !== "BEST_SELLING") {
      shown.sort(function (a, b) {
        if (state.sort === "PRICE_ASC") return num(a) - num(b);
        if (state.sort === "PRICE_DESC") return num(b) - num(a);
        if (state.sort === "TITLE") return (a.getAttribute("data-title") || "").localeCompare(b.getAttribute("data-title") || "");
        return 0;
      });
    } else {
      // Ordre initial
      shown.sort(function (a, b) { return (+a.getAttribute("data-order")) - (+b.getAttribute("data-order")); });
    }
    shown.forEach(function (el) { grid.appendChild(el); });

    updateCount(visible);
    updatePills();
    updateChips();

    if (emptyBox) emptyBox.hidden = visible !== 0;
    if (grid) grid.hidden = visible === 0;
  }

  function num(el) { return parseFloat(el.getAttribute("data-price") || "0"); }

  // Le type d'une chip peut regrouper plusieurs product_types (séparés par ";;").
  function activeTypes() {
    var chip = root.querySelector('[data-ge-cat-chip="' + state.category + '"]');
    var raw = chip ? (chip.getAttribute("data-ge-chip-type") || "") : "";
    return raw.split(";;").filter(Boolean);
  }
  function typeMatches(el, types) {
    var t = el.getAttribute("data-type") || "";
    return types.indexOf(t) !== -1;
  }

  function updateCount(n) {
    if (!countEl) return;
    var word = n > 1 ? T.products : T.product;
    var suffix = hasActive() ? (T.filteredSuffix || "") : "";
    countEl.innerHTML = '<strong class="ge-cat__count-n">' + n + "</strong> " + esc(word) + esc(suffix);
  }

  function hasActive() { return state.brand !== "all" || state.category !== "all" || state.stock; }

  /* ---------- Compteurs des chips ---------- */
  function countFor(fn) { var n = 0; items.forEach(function (el) { if (fn(el)) n++; }); return n; }

  function updateChips() {
    // Compteurs marques (indépendants de la sélection marque, comme le React)
    root.querySelectorAll("[data-ge-brand]").forEach(function (chip) {
      var b = chip.getAttribute("data-ge-brand");
      var n = b === "all" ? items.length : countFor(function (el) { return (el.getAttribute("data-vendor") || "").indexOf(b) !== -1; });
      var badge = chip.querySelector("[data-ge-brand-count]");
      if (badge) badge.textContent = n;
    });

    // Chips catégories : visibles selon marque, comptés, masqués si 0
    root.querySelectorAll("[data-ge-cat-chip]").forEach(function (chip) {
      var handle = chip.getAttribute("data-ge-cat-chip");
      var chipBrand = chip.getAttribute("data-ge-chip-brand") || "All";
      var type = chip.getAttribute("data-ge-chip-type") || "";
      if (handle === "all") {
        var allN = items.length;
        var badgeAll = chip.querySelector("[data-ge-chip-count]");
        if (badgeAll) badgeAll.textContent = allN;
        return;
      }
      // Masquer si marque active ne correspond pas
      var brandMatch = state.brand === "all" || chipBrand === state.brand || chipBrand === "All";
      var typeArr = type.split(";;").filter(Boolean);
      var n = countFor(function (el) { return typeArr.indexOf(el.getAttribute("data-type") || "") !== -1; });
      var badge = chip.querySelector("[data-ge-chip-count]");
      if (badge) badge.textContent = n;
      // Masquée si compteur 0 ou hors marque
      chip.hidden = !brandMatch || n === 0;
    });
  }

  /* ---------- Pills filtres actifs ---------- */
  function updatePills() {
    if (!pillsWrap || !pillsList) return;
    pillsList.innerHTML = "";
    var pills = [];
    if (state.brand !== "all") pills.push({ key: "brand", label: state.brand });
    if (state.category !== "all") {
      var chip = root.querySelector('[data-ge-cat-chip="' + state.category + '"]');
      pills.push({ key: "category", label: chip ? (chip.getAttribute("data-ge-chip-short") || state.category) : state.category });
    }
    if (state.stock) pills.push({ key: "stock", label: T.inStock || "En stock" });

    pills.forEach(function (p) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "ge-cat__pill";
      b.innerHTML = esc(p.label) + '<span class="ge-cat__pill-x">' + xSvg() + "</span>";
      b.addEventListener("click", function () { removeFilter(p.key); });
      pillsList.appendChild(b);
    });
    pillsWrap.hidden = pills.length === 0 || aiActive;
  }

  function xSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
  }

  function removeFilter(key) {
    if (key === "brand") state.brand = "all";
    if (key === "category") state.category = "all";
    if (key === "stock") state.stock = false;
    syncActiveStates();
    applyFilters();
  }

  function resetAll() {
    state.brand = "all";
    state.category = "all";
    state.stock = false;
    syncActiveStates();
    applyFilters();
  }

  /* ---------- États actifs des boutons ---------- */
  function syncActiveStates() {
    root.querySelectorAll("[data-ge-brand]").forEach(function (chip) {
      chip.classList.toggle("is-active", chip.getAttribute("data-ge-brand") === state.brand);
    });
    root.querySelectorAll("[data-ge-cat-chip]").forEach(function (chip) {
      chip.classList.toggle("is-active", chip.getAttribute("data-ge-cat-chip") === state.category);
    });
    var stockBtn = root.querySelector("[data-ge-stock]");
    if (stockBtn) {
      stockBtn.classList.toggle("is-active", state.stock);
      stockBtn.setAttribute("aria-pressed", state.stock ? "true" : "false");
    }
  }

  /* ---------- Interactions filtres ---------- */
  root.querySelectorAll("[data-ge-brand]").forEach(function (chip) {
    chip.addEventListener("click", function () {
      state.brand = chip.getAttribute("data-ge-brand");
      state.category = "all"; // réinitialise la catégorie comme le React
      syncActiveStates();
      applyFilters();
    });
  });
  root.querySelectorAll("[data-ge-cat-chip]").forEach(function (chip) {
    chip.addEventListener("click", function () {
      if (chip.hidden) return;
      state.category = chip.getAttribute("data-ge-cat-chip");
      syncActiveStates();
      applyFilters();
    });
  });
  var stockBtn = root.querySelector("[data-ge-stock]");
  if (stockBtn) stockBtn.addEventListener("click", function () { state.stock = !state.stock; syncActiveStates(); applyFilters(); });
  if (resetBtn) resetBtn.addEventListener("click", resetAll);

  /* ---------- Dropdown de tri ---------- */
  if (sortBtn && sortMenu) {
    sortBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = sortMenu.hidden;
      sortMenu.hidden = !open;
      sortBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    sortMenu.querySelectorAll("[data-ge-sort-opt]").forEach(function (opt) {
      opt.addEventListener("click", function () {
        state.sort = opt.getAttribute("data-ge-sort-opt");
        if (sortLabel) sortLabel.textContent = opt.getAttribute("data-ge-sort-label") || opt.textContent.trim();
        sortMenu.querySelectorAll("[data-ge-sort-opt]").forEach(function (o) { o.classList.toggle("is-active", o === opt); });
        sortMenu.hidden = true;
        sortBtn.setAttribute("aria-expanded", "false");
        applyFilters();
      });
    });
    document.addEventListener("click", function (e) {
      if (!sortMenu.hidden && !sortMenu.contains(e.target) && e.target !== sortBtn && !sortBtn.contains(e.target)) {
        sortMenu.hidden = true;
        sortBtn.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ---------- Recherche IA inline ---------- */
  var aiActive = false;
  var timer = null;
  var controller = null;

  function setAiActive(on) {
    aiActive = on;
    if (toolbar) toolbar.classList.toggle("ge-cat--ai", on); // masque chips/pills via CSS
    if (aiSection) aiSection.hidden = !on;
    if (listing) listing.hidden = on;
  }

  function localFallback(q) {
    var ql = q.toLowerCase();
    var matches = items.filter(function (el) { return (el.getAttribute("data-title") || "").indexOf(ql) !== -1 || (el.getAttribute("data-vendor") || "").toLowerCase().indexOf(ql) !== -1; });
    aiGrid.innerHTML = "";
    matches.forEach(function (el) { aiGrid.appendChild(el.firstElementChild.cloneNode(true)); });
    renderAiHead(matches.length, q, "");
  }

  function renderAiHead(n, q, msg) {
    if (aiHead) {
      if (n > 0) {
        aiHead.innerHTML = '<strong class="ge-cat__count-n">' + n + "</strong> " + esc(fmt(n > 1 ? T.aiResultsFor : T.aiResultFor, esc(q)));
      } else {
        aiHead.textContent = fmt(T.aiNoResultFor, q);
      }
    }
    if (aiMsg) {
      if (msg && n > 0) { aiMsg.textContent = msg; aiMsg.hidden = false; } else { aiMsg.hidden = true; }
    }
    if (aiGrid) aiGrid.hidden = n === 0;
    if (aiEmpty) {
      aiEmpty.hidden = n !== 0;
      if (n === 0 && aiEmptyText) aiEmptyText.textContent = msg || T.aiNoResultHint || "";
    }
  }

  function setSpin(on) {
    if (spinner) spinner.hidden = !on;
    if (clearBtn) clearBtn.hidden = on || !input.value;
  }

  function runAi(q) {
    q = (q || "").trim();
    if (!q) { setAiActive(false); setSpin(false); return; }
    setAiActive(true);
    setSpin(true);
    if (aiHead) aiHead.textContent = fmt(T.aiSearching, q);
    if (aiMsg) aiMsg.hidden = true;
    if (aiEmpty) aiEmpty.hidden = true;
    if (aiGrid) { aiGrid.innerHTML = ""; aiGrid.hidden = false; }

    if (!endpoint) { setSpin(false); localFallback(q); return; }

    if (controller) controller.abort();
    controller = new AbortController();
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: q, isPro: isPro() }),
      signal: controller.signal,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        setSpin(false);
        var products = (data && data.products) || [];
        var msg = (data && data.message) || "";
        aiGrid.innerHTML = "";
        products.forEach(function (p) {
          var existing = items.filter(function (el) { return el.getAttribute("data-handle") === p.handle; })[0];
          if (existing) {
            aiGrid.appendChild(existing.firstElementChild.cloneNode(true));
          } else {
            aiGrid.appendChild(fallbackCard(p));
          }
        });
        renderAiHead(products.length, q, msg);
      })
      .catch(function (e) {
        if (e.name === "AbortError") return;
        setSpin(false);
        localFallback(q);
      });
  }

  function fallbackCard(p) {
    var a = document.createElement("a");
    a.className = "ge-pc__link ge-cat__ai-fallback";
    a.href = "/products/" + esc(p.handle);
    var img = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" class="ge-pc__img">' : "";
    a.innerHTML =
      '<div class="ge-pc"><div class="ge-pc__imgwrap">' + img + "</div>" +
      '<div class="ge-pc__body"><h3 class="ge-pc__title">' + esc(p.title) + "</h3>" +
      '<div class="ge-pc__price"><span class="ge-pc__amount">' + esc(p.price) + '</span><span class="ge-pc__ttc">' + esc(T.taxIncl || "TTC") + "</span></div></div></div>";
    return a;
  }

  function clearSearch() {
    if (input) input.value = "";
    if (clearBtn) clearBtn.hidden = true;
    setSpin(false);
    setAiActive(false);
    if (controller) controller.abort();
    clearTimeout(timer);
  }

  if (input) {
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value;
      if (clearBtn) clearBtn.hidden = !q;
      var trimmed = q.trim();
      if (!trimmed) { clearSearch(); return; }
      if (trimmed.length < 2) return;
      timer = setTimeout(function () { runAi(trimmed); }, 450);
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); clearTimeout(timer); runAi(input.value); }
    });
  }
  if (clearBtn) clearBtn.addEventListener("click", clearSearch);
  Array.prototype.forEach.call(aiClearAll, function (b) { b.addEventListener("click", clearSearch); });

  /* ---------- Init ---------- */
  // Mémorise l'ordre initial pour le tri « Meilleures ventes »
  items.forEach(function (el, i) { el.setAttribute("data-order", i); });
  syncActiveStates();
  applyFilters();
})();
